import { ReactNode } from 'react'
import Youtube from 'src/components/media/youtube'

interface EmptyStateProps {
  title: string
  description?: ReactNode
  imageSource?: string
  actions?: ReactNode
  youtube?: string
}

export default function EmptyState({
  title = '',
  description = '',
  imageSource = '',
  youtube = '',
  actions,
}: EmptyStateProps) {
  return (
    <div className='grid gap-8 overflow-hidden p-8 xl:grid-cols-2 xl:gap-20 xl:p-16'>
      {(imageSource || youtube) && (
        <div className='relative'>
          {youtube ? (
            <>
              {imageSource && (
                <img
                  src={imageSource}
                  alt={title}
                  className='absolute h-full w-full scale-150 object-contain opacity-50'
                />
              )}
              <Youtube video={youtube} />
            </>
          ) : (
            <img src={imageSource} alt={title} className='h-auto w-full max-w-md object-contain' />
          )}
        </div>
      )}
      <div className='relative flex flex-col justify-center gap-6'>
        <div className='flex flex-col justify-center'>
          <h2 className='h2 m-0 mb-5'>{title}</h2>
          <p className='text-light'>{description}</p>
        </div>
        <div className='flex flex-wrap gap-2'>{actions}</div>
      </div>
    </div>
  )
}
